import { Inject, Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ReponseMotifs } from '../models/reponses/reponse-motifs';
import { reponseMotifs } from './json-mocks/reponse-motifs';
import { ReponseInfosClient } from '../models/reponses/reponse-infos-client';
import { reponseInfosClient } from './json-mocks/reponse-infos-client';
import { ReponseFraisResiliation } from '../models/reponses/reponse-frais-resiliation';
import { reponseFraisResiliation } from './json-mocks/reponse-frais-resiliation';
import { RequestFraisResiliation } from '../models/requests/request-frais-resiliation';
import { ReponseEnveloppe } from '../models/reponses/reponse-enveloppe';
import { reponseSaveResiliation } from './json-mocks/reponse-resiliation';
import { ReponseSuivi } from '../models/reponses/reponse-suivi';
import { reponseSuiviResiliation } from './json-mocks/reponse-suivi-resiliation';
import { reponseEligibilite } from './json-mocks/reponse-eligibilite';
import { reponseAnnulation } from './json-mocks/reponse-annulation';
import { reponseValidateEmail } from './json-mocks/reponse-validate-email';
import { SHOW_LOADER, WINDOW } from '@sfcu/sfc-front-starter';
import { RequestDemandeResiliation } from '../models/requests/request-demande-resiliation';
import { InfosClientRecueil } from '../models/infos-client-recueil';
import { reponseInfosClientRecueil } from './json-mocks/reponse-infos-client-recueil';
import { ReponseInfosClientRecueil } from '../models/reponses/reponse-infos-client-recueil';
import { RequestDemandeRecueil } from '../models/requests/request-demande-recueil';
import { reponseSaveRecueil } from './json-mocks/reponse-recueil';

@Injectable({
    providedIn: 'root'
})
export class ResiliationService {

    private url: string;

    constructor(private httpClient: HttpClient,
                @Inject(WINDOW) private window: Window) {

        this.url = this.window.location?.origin + '/resiliation-ws/rest/web/1.0/resil';
    }

    private buildHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'secure': 'false'
        });
    }

    getInfosClient(): Observable<ReponseEnveloppe<ReponseInfosClient>> {
        const headers = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseInfosClient)
            : this.httpClient.get<ReponseEnveloppe<ReponseInfosClient>>(`${this.url}/client`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true),
            });
    }

    getInfosClientRecueil(): Observable<ReponseEnveloppe<ReponseInfosClientRecueil>> {
        const headers = this.buildHeaders();
        /*if (this.window.location?.origin.includes('localhost')) {
            // --- SIMULATION DE L'ERREUR 403 ---
            const mockError = new HttpErrorResponse({
                error: {
                    erreur: {
                        code: 'CLIENT_RECUEIL_NON_AUTORISE',
                        message: 'Accès refusé : Vous n\'avez pas les droits nécessaires (Simulation Local).',
                        titre: 'titre du mock'
                    }
                },
                status: 403,
                statusText: 'Forbidden',
                url: `${this.url}/client-recueil`
            });

            return throwError(() => mockError);
            // ----------------------------------
        }*/

        return this.window.location?.origin.includes('localhost')
            ? of(reponseInfosClientRecueil)
            : this.httpClient.get<ReponseEnveloppe<ReponseInfosClientRecueil>>(`${this.url}/client-recueil`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true),
            });
    }

    getMotifs(isDistrib = false): Observable<ReponseEnveloppe<ReponseMotifs>> {
        const headers: HttpHeaders = this.buildHeaders();
        const profil = isDistrib ? 'DISTRIB' : 'ALL';
        return this.window.location?.origin.includes('localhost')
            ? of(reponseMotifs)
            : this.httpClient.get<ReponseEnveloppe<ReponseMotifs>>(`${this.url}/motifs?profil=${profil}`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true),
            });
    }

    getFraisResiliation(requestFraisResiliation: RequestFraisResiliation): Observable<ReponseEnveloppe<ReponseFraisResiliation>> {
        const headers: HttpHeaders = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseFraisResiliation)
            : this.httpClient.post<ReponseEnveloppe<ReponseFraisResiliation>>(`${this.url}/frais`, requestFraisResiliation, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true)
            });
    }

    enregistrerResiliation(requestDemandeResiliation: RequestDemandeResiliation): Observable<ReponseEnveloppe<boolean>> {
        const formData = new FormData();
        formData.append('file', requestDemandeResiliation.file!);
        requestDemandeResiliation.file = undefined;
        formData.append('resiliationRequest', JSON.stringify(requestDemandeResiliation));

        return this.window.location?.origin.includes('localhost')
            ? of(reponseSaveResiliation)
            : this.httpClient.post<ReponseEnveloppe<boolean>>(`${this.url}/enregistrer`, formData);
    }

    enregistrerRecueil(requestDemandeReceuil: RequestDemandeRecueil): Observable<ReponseEnveloppe<boolean>> {
        const formData = new FormData();
        formData.append('recueilRequest', JSON.stringify(requestDemandeReceuil));

        return this.window.location?.origin.includes('localhost')
            ? of(reponseSaveRecueil)
            : this.httpClient.post<ReponseEnveloppe<boolean>>(`${this.url}/enregistrer-recueil`, formData);
    }

    getSuiviResiliation(number: string): Observable<ReponseEnveloppe<ReponseSuivi>> {
        const headers: HttpHeaders = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseSuiviResiliation)
            : this.httpClient.get<ReponseEnveloppe<ReponseSuivi>>(`${this.url}/suivi/${number}`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true)
            });
    }

    getEligibiliteClient(number: string): Observable<ReponseEnveloppe<boolean>> {
        const headers: HttpHeaders = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseEligibilite)
            : this.httpClient.get<ReponseEnveloppe<boolean>>(`${this.url}/eligible/${number}`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true)
            });
    }

    annulerResiliation(number: string): Observable<ReponseEnveloppe<boolean>> {
        const headers: HttpHeaders = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseAnnulation)
            : this.httpClient.get<ReponseEnveloppe<boolean>>(`${this.url}/annuler/${number}`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true)
            });
    }

    validateEmail(email: string): Observable<ReponseEnveloppe<boolean>> {
        const headers: HttpHeaders = this.buildHeaders();

        return this.window.location?.origin.includes('localhost')
            ? of(reponseValidateEmail)
            : this.httpClient.get<ReponseEnveloppe<boolean>>(`${this.url}/validate-email/${email}`, {
                headers,
                context: new HttpContext().set(SHOW_LOADER, true)
            });
    }

}
